import {Basic, Ventrata} from 'types'

export const formatUnitCounters = (map: Basic.UnitCounterMap, units: Ventrata.Unit[]) => {
  const parts = []

  for (const unit of units) {
    const groupSize = map[unit.id]

    if (groupSize > 0) {
      parts.push(`${unit.title} x ${groupSize}`)
    }
  }

  return parts.join(', ')
}
